// Deep links into the Firebase console for the Outclose project. Outclose user
// IDs are Firebase Auth UIDs, so a user row maps 1:1 to a Firebase account.
export const FIREBASE_PROJECT_ID = 'gayborhood-471323';

/**
 * Firebase Auth users list. The console has no per-user URL, so callers copy
 * the UID to the clipboard alongside opening this so it can be pasted into the
 * console's search box.
 */
export function firebaseAuthUsersUrl(): string {
  return `https://console.firebase.google.com/project/${FIREBASE_PROJECT_ID}/authentication/users`;
}
